export default __webpack_public_path__ + "static/media/article-byyou.3faacf4b.svg";